import { render, staticRenderFns } from "./WatchMobileInstructions.vue?vue&type=template&id=f53ec702&scoped=true&"
import script from "./WatchMobileInstructions.vue?vue&type=script&lang=js&"
export * from "./WatchMobileInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53ec702",
  null
  
)

export default component.exports